import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBitComponent } from './simple-icons-bit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBitComponent ],
    exports:      [ SimpleIconsBitComponent ],
    bootstrap:    []
})
export class SimpleIconsBitModule {}
